import { useEffect, useRef } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { imageUrl } from "@/lib/api";

// Full-screen media viewer (images + optional video) — original quality, no cropping.
export function Lightbox({ media, idx, setIdx, onClose, alt }) {
  const n = media.length;
  const touch = useRef(null);
  const go = (d) => n > 1 && setIdx((i) => (i + d + n) % n);
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); if (e.key === "ArrowRight") go(1); if (e.key === "ArrowLeft") go(-1); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [n]); // eslint-disable-line react-hooks/exhaustive-deps
  const m = media[idx];
  if (!m) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center" dir="ltr" onClick={onClose}
      onTouchStart={(e) => { touch.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => { if (touch.current == null) return; const dx = e.changedTouches[0].clientX - touch.current; touch.current = null; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); }}
      data-testid="lightbox">
      <div className="w-full h-full flex items-center justify-center p-4 sm:p-12" onClick={(e) => e.stopPropagation()}>
        {m.type === "video"
          ? <video key={m.src} src={imageUrl(m.src)} controls autoPlay playsInline className="max-w-full max-h-full rounded-lg bg-black" data-testid="lightbox-video" />
          : <img key={m.src} src={imageUrl(m.src)} alt={alt} className="max-w-full max-h-full object-contain select-none" draggable={false} data-testid="lightbox-image" />}
      </div>
      <button onClick={onClose} className="absolute top-4 right-4 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 text-white flex items-center justify-center" data-testid="lightbox-close"><X className="w-6 h-6" /></button>
      {n > 1 && <>
        <button onClick={(e) => { e.stopPropagation(); go(-1); }} className="absolute left-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 text-white flex items-center justify-center" data-testid="lightbox-prev"><ChevronLeft className="w-6 h-6" /></button>
        <button onClick={(e) => { e.stopPropagation(); go(1); }} className="absolute right-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 text-white flex items-center justify-center" data-testid="lightbox-next"><ChevronRight className="w-6 h-6" /></button>
      </>}
      <span className="absolute bottom-5 left-1/2 -translate-x-1/2 text-white/90 text-sm font-semibold bg-white/10 px-3 py-1 rounded-full" data-testid="lightbox-counter">{idx + 1}/{n}</span>
    </div>
  );
}
